import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import Select, { components } from 'react-select';
import { isAlreadyRenewal, createCart, addRenewalEntry, customerFetch, getPickup, choosePickupStore, updateDelivery, validateCart, calculateCart } from '../../../actions';
import { ConditionEBook } from '../../condition/PaymentCondition';
import { commonConstant, StickyBottom } from '../../../common';
import variables from '../../../common/commonConstant.scss';
import { Collapse, Checkbox, Modal } from '../../../helpers';
import { activityService, addressService, renewalService } from '../../../services';

import './ChooseMagType.scss';
import { RENEWAL_AND_UPGRADE } from '../../../common/commonConstant';
import CustomSweetAlert from '../../../common/customSweetAlert/CustomSweetAlert';
import { getEnvJSON, isBadAddressForRenewUpgrade } from '../../../utill.func';

const liff = window.liff;

const ValueContainer = ({ children, ...props }) => (
  <components.ValueContainer {...props}><img src="/images/Magnifying.svg" alt="" />{children}</components.ValueContainer>
);

export const ChooseMagType = () => {
  const dispatch = useDispatch();
  const didMount = useRef(false);
  const { profile, checkrenew, cart: cartData, addItem, customer, getStore, pickStore, delivery } = useSelector(state => state);
  const [type, setType] = useState();
  const [stores, setStores] = useState();
  const [deliveryType, setDeliveryType] = useState();
  const [deliveryStore, setDeliveryStore] = useState();
  const [modalContent, setModalContent] = useState();
  const [redirect, setRedirect] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const isBtnDisable = !type || showModal || (type === 'physical' && (!deliveryType || (deliveryType === 'atShop' && !deliveryStore)));
  const customerRef = useRef();
  const sendAvtivity = useCallback((status) => {
    activityService.create({
      uid: customer.uid,
      userId: customer._id,
      status: status,
      action: 'SELECT_MAGAZINE_TYPE',
    });
  });
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const backFromPayment = params.get('backFromPayment');
  const [fromBack, setFromBack] = useState(backFromPayment === 'true');

  const code = getEnvJSON('REACT_APP_RENEWAL_CODE');

  useEffect(() => {
    didMount.current = true;
    if (profile.token) {
      dispatch(customerFetch(profile.userId));
    }
  }, []);

  useEffect(() => {

    const isRenewCheck = async () => {
      if (customer.uid && (!customerRef.current || customer.uid !== customerRef.current?.uid)) {
        customerRef.current = customer;
        if (customer.amwayNumber) {
          setLoading(true);
          dispatch(getPickup({ amwayNumber: customer?.amwayNumber, partyId: customer?.partyId }));
          await dispatch(isAlreadyRenewal({ amwayNumber: customer?.amwayNumber, partyId: customer?.partyId }));
        } else if (customer.type) {
          handleToggleModal('NOT_FOUND');
        }
      }
    }
    isRenewCheck();

  }, [customer]);

  useEffect(() => {
    const checkRenewFunc = async () => {
      if (checkrenew.data?.renewalFlag === 'CAN_RENEW' || checkrenew.data?.renewalFlag === 'MUST_RENEW') {
        await dispatch(createCart({ amwayNumber: customer.amwayNumber, partyId: checkrenew.data.partyId, type: customer.type, lineId: customer.uid }));
      } else if (checkrenew.data) {
        handleToggleModal('CANT_RENEW');
      } else if (checkrenew.statusCode && checkrenew.statusCode !== 200) {
        handleToggleModal('ERROR');
      }
      setLoading(false);
    }
    checkRenewFunc();
  }, [checkrenew]);

  useEffect(() => {
    if (getStore.data) {
      setStores(getStore.data.map(store => ({ label: store.displayName, value: store.name })));
      if (customer.type === 'member') {
        setType('physical');
        setDeliveryType('currentAddr');
      }
    } else if ((!getStore.data) && (getStore.code) && (getStore.code !== 200)) {
      handleToggleModal('ERROR');
    }
  }, [getStore]);

  useEffect(() => {
    if ((deliveryType === 'atShop' || (type === 'electronic' && !deliveryType)) && cartData.data && pickStore?.code) {
      dispatch(validateCart(customer.amwayNumber, customer.partyId, cartData.data.code));
    }
  }, [pickStore?.data?.entry?.name]);

  useEffect(() => {
    if (pickStore && pickStore.code && cartData?.validate && !cartData?.isFetch) {
      if (pickStore.code === 200 && cartData?.validate && !fromBack) {
        if (cartData?.validate?.statusCode && cartData?.validate?.statusCode !== 200) {
          CustomSweetAlert({
            title: "",
            text: 'สินค้าบางรายการในตะกร้าของคุณไม่มีจำหน่ายที่สาขาที่คุณเลือก',
            confirmButtonText: "ตกลง",
          });
          setSubmitLoading(false);
        }
        else {
          sendAvtivity('complete');
          setRedirect({
            pathname: commonConstant.pathConfirmPayment,
            state: {
              customerType: customer.type,
              type,
              deliveryType,
            },
          });
        }
      } else {
        if (!fromBack) {
          sendAvtivity('incomplete');
          handleToggleModal('ERROR');
        }
      }
    }
  }, [pickStore?.code, cartData?.isFetch]);

  useEffect(() => {
    if (delivery && delivery.code) {
      if (delivery.code === 200) {
        if ((deliveryType === 'atShop' || (type === 'electronic' && !deliveryType)) && deliveryStore?.value) {
          const currStore = getStore.data.find(s => s.name === deliveryStore.value);
          dispatch(choosePickupStore({ cartCode: cartData.data.code, partyId: customer.partyId, storeId: deliveryStore.value, currStore }));
        } else {
          if (!fromBack) {
            setRedirect({
              pathname: commonConstant.pathConfirmPayment,
              state: {
                customerType: customer.type,
                type,
                deliveryType,
              },
            });
          }
        }
      } else {
        sendAvtivity('incomplete');
        handleToggleModal('ERROR');
      }
    }
  }, [delivery]);

  useEffect(() => {
    if (addItem.data && addItem.data[0].statusCode === 'success' && didMount.current) {
      if (addItem.data && addItem.code === 200) {
        let pickup = null;
        if (deliveryType === 'atShop' || (type === 'electronic' && !deliveryType)) {
          pickup = 'pickup';
          if (type === 'electronic' && !deliveryType) {
            setDeliveryStore({
              label: '',
              value: 'AM-TH-22PS'
            });
          }
        } else if (deliveryType === 'currentAddr') {
          pickup = 'standard-gross';
          submitAddress();
        }
        if (pickup) {
          dispatch(updateDelivery({ cartCode: cartData.data.code, partyId: customer.partyId, pickup: pickup }));
        } else {
          // sendAvtivity('incomplete');
          // handleToggleModal('ERROR');
          const partyId = customer.partyId
          const cartId = cartData.data.code
          const aboId = customer.amwayNumber
          // dispatch(validateCart(aboId, partyId, cartData.data.code))
          // dispatch(calculateCart(aboId, partyId, cartId))
          if (!fromBack) {
            setRedirect({
              pathname: commonConstant.pathConfirmPayment,
              state: {
                customerType: customer.type,
                type,
                deliveryType,
              },
            });
          }
        }
      } else {
        sendAvtivity('incomplete');
        handleToggleModal('ERROR');
      }
    } else if (addItem.data || (addItem.statusCode && addItem.statusCode !== 200)) {
      sendAvtivity('incomplete');
      handleToggleModal('ERROR');
    }
  }, [addItem]);

  const submitAddress = async () => {
    const address = cartData.data && cartData.data.account.primaryParty.defaultAddress;
    const province_name = address.subDistrict;
    const res = await addressService.getProvinces();
    if (res.code === 200) {
      let isocode = address?.country?.isocode;
      const province = res.data.filter((prv) => prv.name == province_name);
      const payload = {
        amwayNumber: customer?.amwayNumber,
        partyId: customer?.partyId,
        cartCode: cartData?.data?.code,
        address: {
          id: address?.id,
          country: {
            isocode: address?.country?.isocode,
          },
          postalCode: address?.postalCode,
          county: address?.district,
          line1: address?.line1,
          district: address?.district,
          subDistrict: address?.subDistrict,
          region: {
            countryIso: address?.country?.isocode,
            isocode: isocode || 'BK',
          },
          town: address?.town,
        },
      };
      setLoading(true);
      await renewalService.updateDeliveryAddress(payload);
      setLoading(false);
    }
  };


  const handleSubmit = () => {

    const isBadAddress = cartData?.data && cartData?.data?.account?.primaryParty?.defaultAddress && isBadAddressForRenewUpgrade(cartData?.data?.account?.primaryParty?.defaultAddress);
    if (!cartData || !cartData.data || isBadAddress) {
      handleToggleModal('CANT_RENEW');
      return;
    }

    setSubmitLoading(true);
    setFromBack(false);
    dispatch(addRenewalEntry({ cartCode: cartData.data.code, partyId: customer.partyId, aboId: customer.amwayNumber, code: customer.type === 'abo' && type === 'physical' ? code[customer.type][type][deliveryType] : code[customer.type][type] }));
  };

  const handleToggleModal = (content) => {
    setLoading(false);
    setModalContent(content);
    setShowModal(show => !show);
  };

  const handleModalContent = () => {
    switch (modalContent) {
      case 'ERROR':
        return {
          content: 'เกิดข้อพิดพลาด กรุณาลองใหม่ในภายหลัง',
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'ปิด',
          fnOk: () => liff.closeWindow(),
        };
      case 'CANT_RENEW':
        return {
          content: <> กรุณาเช็คสถานะการต่ออายุได้ที่เมนูบัญชีของฉัน<br />
            <a href={`https://liff.line.me/${process.env.REACT_APP_CLIENT_ID}?seamless=/my-account`}>https://www.amway.co.th/my-account</a><br />
            หรือติดต่อ Amway Contact Center <a href="tel:027258000">027258000</a></>,
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'โทร',
          fnOk: () => window.location = 'tel:027258000',
        };
      case 'NOT_FOUND':
        return {
          content: 'ไม่พบข้อมูลสมาชิก กรุณาติดต่อ 02-725-8000',
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'โทร',
          fnOk: () => window.location = 'tel:027258000',
        };
      default:
        return;
    }
  };

  const primaryAddress = cartData?.data ? cartData.data.account.primaryParty.defaultAddress.formattedAddress : "";
  const aboObj = RENEWAL_AND_UPGRADE.ABO_RENEWAL;
  const memberObj = RENEWAL_AND_UPGRADE.MEMBER_RENEWAL;

  const handleRenderBody = (memberType) => {
    switch (memberType) {
      case 'abo':
        return (
          <>
            <Collapse title={
              <Checkbox checked={type === 'electronic'} checkmarkColor={variables.success} svg={<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.38155 0.360155C8.81047 -0.068765 9.50504 -0.146477 9.95753 0.301416C10.1841 0.498115 10.2918 0.785691 10.2995 1.06393C10.3073 1.34183 10.2158 1.62956 10.0188 1.82819L4.33166 8.06223C3.88893 8.5668 3.12751 8.56664 2.68499 8.06174L0.275862 5.3788C-0.101527 4.93847 -0.102047 4.2477 0.33839 3.80722L0.346847 3.79939C0.78717 3.422 1.47794 3.42148 1.91842 3.86192L1.92465 3.86853L3.5106 5.65913L8.38155 0.360155Z" fill="white" />
              </svg>}>
                <div className='book-type-title-width-recommend'>
                  <div className='book-type-title'>รับนิตยสารอะชีฟรูปแบบอิเล็กทรอนิกส์</div>
                </div>
              </Checkbox>
            }
              image={aboObj.estarterImageIcon}
              standalone isCollpased={type !== 'electronic'} onClick={() => {
                setType('electronic');
                setDeliveryType();
              }}
              hideSuffix
            >
            </Collapse>
            <Collapse title={
              <Checkbox checked={type === 'physical'} checkmarkColor={variables.success} svg={<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.38155 0.360155C8.81047 -0.068765 9.50504 -0.146477 9.95753 0.301416C10.1841 0.498115 10.2918 0.785691 10.2995 1.06393C10.3073 1.34183 10.2158 1.62956 10.0188 1.82819L4.33166 8.06223C3.88893 8.5668 3.12751 8.56664 2.68499 8.06174L0.275862 5.3788C-0.101527 4.93847 -0.102047 4.2477 0.33839 3.80722L0.346847 3.79939C0.78717 3.422 1.47794 3.42148 1.91842 3.86192L1.92465 3.86853L3.5106 5.65913L8.38155 0.360155Z" fill="white" />
              </svg>}>
                <div className='book-type-title'>รับเป็นรูปเล่ม</div>
                <p className='book-type-subtitle'>ชุดคู่มือนักธุรกิจแอมเวย์จะจัดส่งให้ตามที่อยู่ปัจจุบัน</p>
              </Checkbox>
            }
              image={aboObj.physicalImageIcon}
              standalone isCollpased={type !== 'physical'} onClick={() => setType('physical')}
              hideSuffix
            >
              <div className='achieve-title'>เลือกวิธีการจัดส่ง</div>
              <div>
                <Collapse title={
                  <Checkbox checked={deliveryType === 'currentAddr'} checkmarkColor={variables.success} svg={<svg width="9" height="8" style={{ top: "4px", left: "4px" }} viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6.70524 1.08744C7.04838 0.744304 7.60403 0.682135 7.96602 1.04045C8.14728 1.19781 8.23345 1.42787 8.23963 1.65046C8.2458 1.87278 8.17263 2.10297 8.01506 2.26187L3.46533 7.2491C3.11115 7.65275 2.50201 7.65262 2.14799 7.24871L0.220689 5.10235C-0.0812216 4.75009 -0.0816374 4.19748 0.270712 3.84509L0.277478 3.83883C0.629736 3.53692 1.18235 3.5365 1.53474 3.88885L1.53972 3.89414L2.80848 5.32662L6.70524 1.08744Z" fill="white" />
                  </svg>} checkClass="sm">
                    <div className='book-type-title-sm'>จัดส่ง (ที่อยู่ปัจจุบัน)</div>
                  </Checkbox>
                }
                  standalone isCollpased={deliveryType !== 'currentAddr'}
                  onClick={() => setDeliveryType('currentAddr')} onChange={() => { }}
                  hideSuffix
                >
                  <div className='book-type-subtitle primary-address'>{primaryAddress}</div>
                </Collapse>
              </div>
              <div>
                <Collapse title={
                  <Checkbox checked={deliveryType === 'atShop'} checkmarkColor={variables.success} svg={<svg width="9" height="8" style={{ top: "4px", left: "4px" }} viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6.70524 1.08744C7.04838 0.744304 7.60403 0.682135 7.96602 1.04045C8.14728 1.19781 8.23345 1.42787 8.23963 1.65046C8.2458 1.87278 8.17263 2.10297 8.01506 2.26187L3.46533 7.2491C3.11115 7.65275 2.50201 7.65262 2.14799 7.24871L0.220689 5.10235C-0.0812216 4.75009 -0.0816374 4.19748 0.270712 3.84509L0.277478 3.83883C0.629736 3.53692 1.18235 3.5365 1.53474 3.88885L1.53972 3.89414L2.80848 5.32662L6.70524 1.08744Z" fill="white" />
                  </svg>} checkClass="sm">
                    <div className='book-type-title-sm'>รับด้วยตัวเอง</div>
                  </Checkbox>
                }
                  standalone isCollpased={deliveryType !== 'atShop'}
                  onClick={() => setDeliveryType('atShop')} onChange={() => { }}
                  hideSuffix
                >
                  <Select classNamePrefix="react-select" options={stores} menuPortalTarget={document.querySelector('.choosemag-container')} menuShouldScrollIntoView={true}
                    onChange={(e) => setDeliveryStore(e)}
                    placeholder="ค้นหาร้านแอมเวย์"
                    className={deliveryType === 'atShop' ? 'visible' : 'hide'}
                    components={{
                      ValueContainer,
                    }}
                    value={deliveryStore}
                    styles={{
                      indicatorsContainer: styles => ({ ...styles, display: 'none' }),
                      menu: styles => ({ ...styles, top: 0, marginTop: '5px' }),
                      control: styles => ({
                        ...styles,
                        borderRadius: '8px',
                        boxShadow: 'none',
                        marginTop: '5px'
                      }),
                      placeholder: styles => ({ ...styles, marginLeft: '20px', maxWidth: 'calc(100% - 32px)' }),
                      singleValue: styles => ({ ...styles, marginLeft: '20px', maxWidth: 'calc(100% - 32px)' }),
                      input: styles => ({ ...styles, marginLeft: '7px' }),
                    }} />
                </Collapse>
              </div>
            </Collapse>
          </>
        );
      case 'member':
        return (
          <>
            <div className='member-manual-image'>
              <img src={memberObj.memberManualImageIcon} />
            </div>
            <Collapse title={
              <Checkbox checked={deliveryType === 'currentAddr'} checkmarkColor={variables.success} svg={<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.38155 0.360155C8.81047 -0.068765 9.50504 -0.146477 9.95753 0.301416C10.1841 0.498115 10.2918 0.785691 10.2995 1.06393C10.3073 1.34183 10.2158 1.62956 10.0188 1.82819L4.33166 8.06223C3.88893 8.5668 3.12751 8.56664 2.68499 8.06174L0.275862 5.3788C-0.101527 4.93847 -0.102047 4.2477 0.33839 3.80722L0.346847 3.79939C0.78717 3.422 1.47794 3.42148 1.91842 3.86192L1.92465 3.86853L3.5106 5.65913L8.38155 0.360155Z" fill="white" />
              </svg>}>
                จัดส่ง (ที่อยู่ปัจจุบัน)
              </Checkbox>
            }
              standalone
              isCollpased={deliveryType !== 'currentAddr'}
              onClick={() => setDeliveryType('currentAddr')}
              hideSuffix
            >
              <div className='book-type-subtitle primary-address'>{primaryAddress}</div>
            </Collapse>
            <Collapse title={
              <Checkbox checked={deliveryType === 'atShop'} checkmarkColor={variables.success} svg={<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.38155 0.360155C8.81047 -0.068765 9.50504 -0.146477 9.95753 0.301416C10.1841 0.498115 10.2918 0.785691 10.2995 1.06393C10.3073 1.34183 10.2158 1.62956 10.0188 1.82819L4.33166 8.06223C3.88893 8.5668 3.12751 8.56664 2.68499 8.06174L0.275862 5.3788C-0.101527 4.93847 -0.102047 4.2477 0.33839 3.80722L0.346847 3.79939C0.78717 3.422 1.47794 3.42148 1.91842 3.86192L1.92465 3.86853L3.5106 5.65913L8.38155 0.360155Z" fill="white" />
              </svg>}>
                <div>รับด้วยตัวเอง</div>
              </Checkbox>
            }
              standalone
              isCollpased={deliveryType !== 'atShop'}
              onClick={() => setDeliveryType('atShop')}
              hideSuffix
            >
              <Select classNamePrefix="react-select" options={stores} menuPortalTarget={document.querySelector('body')}
                onChange={(e) => setDeliveryStore(e)}
                placeholder="ค้นหาร้านค้าแอมเวย์"
                className={deliveryType === 'atShop' ? 'visible' : 'hide'}
                components={{
                  ValueContainer,
                }}
                value={deliveryStore}
                styles={{
                  indicatorsContainer: styles => ({ ...styles, display: 'none' }),
                  menu: styles => ({ ...styles, top: 0, marginTop: '5px' }),
                  control: styles => ({
                    ...styles,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    marginTop: '5px',
                  }),
                  placeholder: styles => ({ ...styles, marginLeft: '20px', maxWidth: 'calc(100% - 32px)' }),
                  singleValue: styles => ({ ...styles, marginLeft: '20px', maxWidth: 'calc(100% - 32px)' }),
                  input: styles => ({ ...styles, marginLeft: '7px' }),
                }} />
            </Collapse>
            <div className="medium-blue">
              *นิตยสารแอมนิวส์รูปแบบดิจิทัลจะส่งถึงคุณทุกวันที่ 1 ของ
              เดือน ผ่านทาง LINE หรือ SMS ที่ได้ลงทะเบียนไว้กับบริษัท
            </div>
          </>
        );
      default:
        return;
    }
  };

  const content = handleModalContent();

  if (loading) {
    return <div> <LoadingOverlay
      active={true}
      spinner
      text="Loading"
      styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', pointerEvents: 'none', top: 0, left: 0 } }}
    /></div>;
  }
  if (redirect) {
    return <Redirect to={redirect} />;
  }
  return (

    <div className="choosemag-container">
      {
        //to fix label issue
        submitLoading && <LoadingOverlay
          active={true}
          spinner
          text="Loading"
          styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 } }}
        />
      }
      {

        showModal && <Modal
          content={content.content}
          type={content.type}
          fnClose={() => setShowModal(false)}
          fnOk={content.fnOk}
          fnCancel={content.cancleBtn ? () => setShowModal(false) : null}
          closeBtn={content.closeBtn}
          okBtn={content.okBtn}
          okText={content.okText}
          cancleText="ยกเลิก" />
      }
      <div className="header">
        <div className="title">{customer.type === 'abo' ? 'เลือกรูปแบบการต่ออายุ' : 'เลือกวิธีจัดส่งคู่มือสมาชิกแอมเวย์'}</div>
        <div className="desc">{customer.type === 'abo' ? 'ค่าธรรมเนียมต่ออายุนักธุรกิจแอมเวย์ 450 บาท' : 'ค่าธรรมเนียมต่ออายุสมาชิกแอมเวย์ 100 บาท'}</div>
      </div>
      <div className="body">
        {handleRenderBody(customer.type)}
      </div>
      <StickyBottom isActive={!isBtnDisable} onClick={handleSubmit} buttonText="ยืนยัน" buttonProps={{ type: "submit", disabled: isBtnDisable, style: { marginTop: 20 } }} >
        {!isBtnDisable &&
          <div className="starter-kit-footer-wrapper">
            <h6 className='application-fee-title'>ค่าธรรมเนียมการต่ออายุ</h6>
            <h5 className='application-fee-value'>฿ {customer.type === 'abo' ? '450' : '100'}</h5>
          </div>
        }
      </StickyBottom>
    </div>
  );
};


const PaymentConsent = ({ onClick }) => (
  <div className="payment-consent-container">
    <ConditionEBook />
    <div className="card-footer">
      <button className="away-button active" onClick={onClick}>กลับ</button>
    </div>
  </div>
);

